export default __webpack_public_path__ + "static/UniversLTW04-73BlackExt-a28fdb10a09cb3b40b3eeb552cfa02e9.woff";